import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Wallet from "./icons/Wallet";
import {Shopping as ShoppingIcon} from "./icons/Shopping";
import Settings from "./icons/Settings";
import Logout from "./icons/Logout";
import {Timeline as TimelineIcon} from "./icons/Timeline";
import { SESSSION_OUT } from "../../../../Utils/constants";
import { isFeatureDisabled, isPermission } from "../../../../Utils";
import FamilyPeople from "./icons/settings/FamilyPeople";
import {Chores as ChoreIcon} from "./icons/Chores";
import Charities from "./icons/Charities";
import SuperpowerBulb from "./icons/SuperpowerBulb";
import EducationIcon from "./icons/EducationIcon";

const Sidebar = ( props ) => {

  const { t } = useTranslation();
  const location = useLocation();
  const isBank = !props.showHeader || sessionStorage.getItem("__bank");
  const activeColor = props.state.theme.values.primaryColor;
  const defaultColor = props.state.theme.values.tertiaryGrayColor;
  const logout = () => {
    SESSSION_OUT(props);
  };

  const toggleSidebar = () => {
    document.querySelector('.parent-left-sidebar').classList.toggle('active');
  }

  const setActiveBackground = (e) => {
    return window.location.pathname === e ? props.state.theme.values.primaryColor+14 : 'transparent';
  }

  const setMyFamilyActiveBackground = () => {
    return (window.location.pathname === '/parent/dashboard' ||
       window.location.pathname === '/parent/children/detail' || 
       window.location.pathname === '/parent/children/setting') ? props.state.theme.values.primaryColor+14 : 'transparent';
  }

  return (
    <div className="parent-left-sidebar">
      <ul>
        <li onClick={toggleSidebar} className={`${(
            location.pathname === "/parent/dashboard" ||
            location.pathname === "/parent/children/detail" ||
            location.pathname === "/parent/children/setting" 
          ) ? 'active' : ''}`} style={{backgroundColor : setMyFamilyActiveBackground()}} >
          <Link to="/parent/dashboard">
            <span className="menu-icon">
              <span className="svgIcon">
                <FamilyPeople {...props} color={(
                  location.pathname === "/parent/dashboard" ||
                  location.pathname === "/parent/children/detail" ||
                  location.pathname === "/parent/children/setting" 
                  ) ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('my_family')}</span>
          </Link>
        </li>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/chores" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/chores')}}>
          <Link to="/parent/chores">
            <span className="menu-icon">
              <span className="svgIcon">
                <ChoreIcon {...props} color={location.pathname === "/parent/chores" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('chores')}</span>
          </Link>
        </li>
        {isPermission(props, `Shopping`) === true &&
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/shopping" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/shopping')}}>
          <Link to="/parent/shopping">
            <span className="menu-icon">
              <span className="svgIcon">
                <ShoppingIcon color={location.pathname === "/parent/shopping" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('shopping')}</span>
          </Link>
        </li>
        }
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/education" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/education')}}>
          <Link to="/parent/education">
            <span className="menu-icon">
              <span className="svgIcon">
                <EducationIcon {...props} color={location.pathname === "/parent/education" ?  activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('education')}</span>
          </Link>
        </li>
        {!isPermission(props, `Whitelabel`) === true &&
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/wallet" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/wallet')}}>
          <Link to="/parent/wallet">
            <span className="menu-icon">
              <span className="svgIcon">
                <Wallet {...props} color={location.pathname === "/parent/wallet" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('wallet')}</span>
          </Link>
        </li>
        }
        {isPermission(props, `Whitelabel`) === true &&
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/transfer" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/transfer')}}>
          <Link to="/parent/transfer">
            <span className="menu-icon">
              <span className="svgIcon">
                <Wallet {...props} color={location.pathname === "/parent/transfer" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('transfer')}</span>
          </Link>
        </li>
        }
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/timeline" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/timeline')}}>
          <Link to="/parent/timeline">
            <span className="menu-icon">
              <span className="svgIcon">
                <TimelineIcon {...props} color={location.pathname === "/parent/timeline" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('timeline')}</span>
          </Link>
        </li>
        {isPermission(props, `Charity`) === true &&
          <li onClick={toggleSidebar} className={`${location.pathname === "/parent/charities" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/charities')}}>
            <Link to="/parent/charities">
              <span className="menu-icon">
                <span className="svgIcon">
                  <Charities color={location.pathname === "/parent/charities" ? activeColor : defaultColor}/>
                </span>
              </span>
              <span>{t('charities')}</span>
            </Link>
          </li>
        }
      </ul>
      <ul>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/setting/dashboard" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/parent/setting/dashboard')}}>
          <Link to="/parent/setting/dashboard">
            <span className="menu-icon">
              <span className="svgIcon">
                <Settings {...props} color={location.pathname === "/parent/setting/dashboard" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('settings')}</span>
          </Link>
        </li>
        {!isBank && 
          <li onClick={toggleSidebar} className={`${location.pathname === "/parent/logout" ? 'active' : ''}`}>
            <a href="#logout" onClick={logout}>
              <span className="menu-icon">
                <span className="svgIcon">
                  <Logout {...props} color={props.state.theme.values.tertiaryGrayColor}/>
                </span>
              </span>
              <span>{t('sign_out')}</span>
            </a>
          </li>
        }
      </ul>
    </div>
  );
};

export default Sidebar;
